"use client";

import React from "react";
import { Facebook, Instagram, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
const cities = ["Aurora", "Plainfield", "Oswego", "Bolingbrook", "Naperville", "Montgomery", "Yorkville", "Lisle"];
const socials = [{
  icon: Facebook,
  href: "https://facebook.com/realestatewithanish",
  label: "Facebook"
}, {
  icon: Instagram,
  href: "https://instagram.com/realestatewithanish",
  label: "Instagram"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="225354" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted/20 animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-ring transition-colors font-default text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function RodapeInformativo() {
  return <footer className="bg-background border-t border-border pt-16 pb-8 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          
          {}
          <div className="md:col-span-4 space-y-6">
            <Link to="/">
              <WvcLogo className="h-21 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-sm">
              Helping families find their dream homes in Aurora, Plainfield, and surrounding Naperville areas with expert local knowledge and dedicated service.
            </p>
            <div className="flex gap-4">
              {socials.map((social, i) => <Link key={social.label} to={social.href} newTab data-index={i} className="p-2 rounded-lg bg-muted hover:bg-ring hover:text-primary-foreground transition-all duration-300">
                  <social.icon className="size-5" />
                </Link>)}
            </div>
            <div className="pt-2">
              <p className="text-xs text-muted-foreground/60 uppercase tracking-wider font-semibold leading-loose">Illinois LicenseD ReaLTOR<br />Equal Housing Opportunity</p>
            </div>
          </div>

          {}
          <div className="md:col-span-4">
            <h4 className="font-bold text-foreground mb-6 text-sm uppercase tracking-widest">Service Areas</h4>
            <div className="grid grid-cols-2 gap-2">
              {cities.map((city, i) => <button key={city} data-index={i} className="bg-muted hover:bg-ring text-sm px-3 py-2 rounded-lg transition-colors text-left text-muted-foreground hover:text-primary-foreground w-full">
                  {city}
                </button>)}
            </div>
          </div>

          {}
          <div className="md:col-span-4 flex flex-col md:items-start space-y-8">
            <h4 className="font-bold text-foreground text-lg uppercase tracking-widest mb-2">Contact Us</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-6 w-full">
              <div className="group p-4 rounded-lg bg-muted/30 hover:bg-muted transition-colors">
                <h5 className="text-xs font-bold text-foreground uppercase tracking-widest mb-3">Mobile</h5>
                <Link to="tel:8155460725" className="flex items-center gap-3 text-muted-foreground hover:text-ring transition-colors text-base font-medium">
                  <Phone className="size-4" />
                  815-546-0725
                </Link>
              </div>
              <div className="group p-4 rounded-lg bg-muted/30 hover:bg-muted transition-colors">
                <h5 className="text-xs font-bold text-foreground uppercase tracking-widest mb-3">Email</h5>
                <Link to="mailto:realestatewithanish@gmail.com" className="flex items-center gap-3 text-muted-foreground hover:text-ring transition-colors text-base font-medium break-all">
                  <Mail className="size-4 shrink-0" />
                  realestatewithanish@gmail.com
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="hidden">
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>
        </div>

        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col items-center md:items-start gap-2">
            
          </div>
        </div>
      </div>
    </footer>;
}